import { render } from "./Usps.vue?vue&type=template&id=13cd55e4"
const script = {}
script.render = render

export default script